import {useTheme, VStack} from '@chakra-ui/react'
import dayjs from 'dayjs'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import {FREE_PLAN, TWO_WEEKS} from '../../constants/plans'
import Plan from '../../dataModels/Plan'
import PriceSubscription from '../Modules/PriceSubscription'

interface Props {
  currentSubscriptionPeriodEnd: number
  currentSubscriptionUsage: number
  currentPlan: Plan
  userInscriptionDate: number
}

const UserUtilisation = ({
  currentSubscriptionPeriodEnd,
  currentSubscriptionUsage,
  currentPlan,
  userInscriptionDate,
}: Props) => {
  const theme = useTheme()

  const {t} = useTranslation()

  let nbOfGenerations = currentPlan.nbOfGenerations

  if (currentPlan == FREE_PLAN) {
    const isInfirst14Days = Date.now() - userInscriptionDate < TWO_WEEKS
    if (isInfirst14Days) {
      currentSubscriptionPeriodEnd = userInscriptionDate + TWO_WEEKS
      nbOfGenerations = currentPlan.nbOfGenerations14firstDays!
    }
  }
  debugger
  return (
    <VStack
      w='full'
      p={5}
      spacing={5}
      borderRadius={theme.radii.big}
      background={theme.colors.layers.appLevel1}
      align='start'>
      <PriceSubscription
        monthlyBudget={currentPlan.nbOfGenerations}
        remainingBudget={nbOfGenerations - currentSubscriptionUsage}
        renewDate={dayjs(currentSubscriptionPeriodEnd)}
        // @ts-ignore
        plan={t(currentPlan.keyName)}
        icon={<Image width={42} height={42} src={currentPlan.icon} alt='' />}
        price={currentPlan.price}
        free={currentPlan == FREE_PLAN}
        first14DayBudget={
          currentPlan == FREE_PLAN ? FREE_PLAN.nbOfGenerations14firstDays : undefined
        }
      />
    </VStack>
  )
}
export default UserUtilisation
